import {
  Box,
  CircularProgress,
  Container,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import CustomButton from "../../../../Components/Button/CustomButton";
import backbluebtn from "../../../../Utils/Images/backbluebtn.png";
import gallary from "../../../../Utils/Images/Gallerywhite.png";
import CustomInput from "../../../../Components/input/CustomInput";
import { handleAddRecipe } from "../../../../APIs/Function/Workout/Recipe/AddRecipe";

const AddRecipePlans = () => {
  const [previewImage, setPreviewImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [imagea, setimagea] = useState([]);
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    recipe_type: "",
    images: previewImage,
  });

  const initialFormData = {
    title: "",
    description: "",
    recipe_type: "",
    images: null,
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const blobToFile = (blob, name) => {
    const file = new File([blob], name, { type: blob.type });
    return file;
  };
  const handleSubmit = async () => {
    const updatedFormData = {
      ...formData,
      images: imagea,
    };
    if (
      formData.title !== "" &&
      formData.description.trim() !== "" &&
      formData.recipe_type &&
      updatedFormData.images.length
    ) {
      try {
        setLoading(true);
        await handleAddRecipe(updatedFormData);
        setFormData(initialFormData);
        setPreviewImage([]);
        setimagea([]); // Reset imagea state after submitting
        setLoading(false);
        alert("Recipe Added Successfully");
        navigate("/recipeplans");
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    } else {
      alert("Please Fill All The Fields Correctly");
    }
  };
  const handleFileChange = (event) => {
    const selectedFiles = event.target.files;
    const fileObjects = [];

    for (let i = 0; i < selectedFiles.length; i++) {
      const objectURL = URL.createObjectURL(selectedFiles[i]);
      const file = blobToFile(selectedFiles[i], selectedFiles[i].name);
      fileObjects.push(file);
    }
    setPreviewImage(fileObjects);
    setimagea(fileObjects);
    setFormData({
      ...formData,
      images: fileObjects,
    });
  };
  console.log(previewImage);
  return (
    <>
      {/* header */}
      <Box
        sx={{
          bgcolor: "#31AEF4",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: { xs: "50px", md: "70px", lg: "70px" },
          p: "10px",
          boxSizing: "border-box",
        }}
      >
        <Link to={"/recipeplans"}>
          <Box
            sx={{
              height: { xs: "50px", md: "60px", lg: "60px" },
              display: "flex",
              alignItems: "center",
            }}
          >
            <img height={"100%"} src={backbluebtn} alt="back" />
          </Box>
        </Link>
        <Box>
          <Typography
            sx={{
              fontFamily: "Open Sans",
              fontSize: { md: "30px", sm: "20px" },
              fontWeight: 600,
              lineHeight: "36px",
              color: "#FFFFFF",
            }}
          >
            Add Recipe
          </Typography>
        </Box>
        <Box>
          <CustomButton
            onClick={handleSubmit}
            sx={{
              width: { xs: "40px", md: "50px", lg: "80px" },
              height: { xs: "10px", md: "50px", lg: "50px " },
            }}
          >
            {loading ? <CircularProgress></CircularProgress> : "Save"}
          </CustomButton>
        </Box>
      </Box>
      <Box
        sx={{
          p: 2,
          boxSizing: "border-box",
          display: "flex",
          justifyContent: "center ",
        }}
      >
        {/* Form */}
        <Box
          sx={{
            mt: "10px",
            border: "1px solid #E8E8E8",
            width: "45%",
            boxSizing: "border-box",
            p: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between ",
              alignItems: "center",
              boxSizing: "border-box",
              p: 1,
            }}
          >
            <Box>
              <Typography
                sx={{
                  fontFamily: "inter",
                  fontWeight: 400,
                  fontSize: "20px",
                  lineHeight: "20px",
                }}
              >
                Gallary
              </Typography>
            </Box>
            <Box>
              <label htmlFor="file-input">
                <Box
                  sx={{
                    display: "flex",
                    bgcolor: "#000000",
                    height: "50px",
                    gap: "5px ",
                    alignItems: "center",
                    borderRadius: "5px",
                    p: 2,
                    boxSizing: "border-box",
                    cursor: "pointer",
                  }}
                >
                  <Typography
                    sx={{
                      color: "#FFFFFF",
                      fontFamily: "inter",
                      fontWeight: 400,
                      fontSize: "16px",
                      lineHeight: "16px",
                    }}
                  >
                    Upload Image
                  </Typography>
                  <Box sx={{ width: "25px", height: "25px" }}>
                    <img width={"100%"} src={gallary} alt="gallary" />
                  </Box>
                </Box>
              </label>
              <input
                accept="image/*"
                type="file"
                id="file-input"
                multiple
                onChange={handleFileChange}
                style={{ display: "none" }}
              />
            </Box>
          </Box>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
            {previewImage
              ? previewImage.map((blob, i) => (
                  <Box key={i} sx={{ width: "30%", height: "200px" }}>
                    <img
                      style={{ borderRadius: "10px" }}
                      width={"100%"}
                      height={"100%"}
                      src={URL.createObjectURL(blob)}
                      alt="preview"
                    />
                  </Box>
                ))
              : ""}
          </Box>
        </Box>
        <Box sx={{ width: "45%" }}>
          <Container maxWidth="sm" sx={{ mt: "10px" }}>
            <form onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <CustomInput
                    label="Title"
                    name="title"
                    value={formData.title}
                    onChange={handleInputChange}
                    fullWidth
                    required
                  />
                </Grid>
                <Grid item xs={12}>
                  <CustomInput
                    label="Description"
                    name="description"
                    value={formData.description}
                    onChange={handleInputChange}
                    fullWidth
                    multiline
                    rows={4}
                    required
                  />
                </Grid>
                <Grid item xs={12} sx={{ mt: "15px" }}>
                  <FormControl fullWidth required>
                    <InputLabel
                      htmlFor="recipe-type-select"
                      sx={{
                        backgroundColor: "#FFF",
                      }}
                    >
                      Recipe Type
                    </InputLabel>
                    <Select
                      name="recipe_type"
                      value={formData.recipe_type}
                      onChange={handleInputChange}
                      sx={{
                        textAlign: "left",
                      }}
                    >
                      <MenuItem value={1}>Morning</MenuItem>
                      <MenuItem value={2}>Afternoon</MenuItem>
                      <MenuItem value={3}>Evening</MenuItem>
                      <MenuItem value={4}>Anytime</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </form>
          </Container>
        </Box>
      </Box>
    </>
  );
};

export default AddRecipePlans;
